import * as React from "react";

const FileUploadIcon = (props: any) => (
  <svg style={{ color: 'var(--brand, #365d7e)' }} width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3091_2766)">
<path d="M8.00033 9.39941V5.73275C8.00033 5.18046 8.44806 4.73275 9.00033 4.73275C9.55259 4.73275 10.0003 5.18046 10.0003 5.73275V9.39941C10.0003 10.504 9.10493 11.3994 8.00033 11.3994C6.89573 11.3994 6.00033 10.504 6.00033 9.39941V6.73275M5.86699 14.7327H10.1337C11.2538 14.7327 11.8138 14.7327 12.2417 14.5147C12.618 14.323 12.9239 14.0171 13.1157 13.6407C13.3337 13.2129 13.3337 12.6529 13.3337 11.5327V4.59941C13.3337 3.47931 13.3337 2.91925 13.1157 2.49143C12.9239 2.11511 12.618 1.80915 12.2417 1.6174C11.8138 1.39941 11.2538 1.39941 10.1337 1.39941H5.86699C4.74689 1.39941 4.18683 1.39941 3.75901 1.6174C3.38269 1.80915 3.07673 2.11511 2.88498 2.49143C2.66699 2.91925 2.66699 3.47931 2.66699 4.59941V11.5327C2.66699 12.6529 2.66699 13.2129 2.88498 13.6407C3.07673 14.0171 3.38269 14.323 3.75901 14.5147C4.18683 14.7327 4.74689 14.7327 5.86699 14.7327Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_3091_2766">
<rect width="16" height="16" fill="white" transform="translate(0 0.0664062)"/>
</clipPath>
</defs>
</svg>
);

export default FileUploadIcon;
